import $ from 'jquery';
import 'slick-carousel';
import Viewport from './Viewport';

const mobileBreakpoint = 767;
const settings = {
  fade: true,
  dots: true,
  arrows: false,
};

export default class EventSlider {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.viewport = new Viewport(mobileBreakpoint);
    this.viewport.onMobileChange(this.addSlider.bind(this));
    this.viewport.onDesktopChange(this.removeSlider.bind(this));
    this.viewport.update();
  }

  addSlider() {
    this.$element.find('.view-content').slick(settings);
  }

  removeSlider() {
    this.$element.find('.slick-initialized').slick('unslick');
  }
}
